import { IconType, SvgIcon } from './SvgIcon';

export const RecordingIcon: IconType = (props) => (
  <SvgIcon {...props} viewBox="0 0 12 12">
    <rect width="12" height="12" rx="6" fill="currentColor" />
    <rect x="3" y="3" width="6" height="6" rx="3" fill="#D13637" />
  </SvgIcon>
);

RecordingIcon.displayName = 'RecordingIcon';
